module.exports = __webpack_public_path__ + "img/banner-escritorio.8da0327c.jpg";